import React from "react";
import "./LoadingSpinner.scss";

export default function LoadingSpinner() {
    return (
        <div className="loading">Loading</div>
    );
}